import React, { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { ShapeTable } from "@routes/IconeSvg";

import Button from "@components/tailwindComponents/Button";
import BlackTooltip from "@components/tooltip/BlackTooltip";

export default function QuestionItem({
  handleShowModalAnswer,
  selectedSurveyRequest
}) {
  const { t: translator } = useTranslation("assesment.frequency");

  const [fadeStatus, setFadeStatus] = useState(false);
  const toggleFadeStatus = () => {
    setFadeStatus((_fadeStatus) => !_fadeStatus);
  };

  const surveyQuestions = useReduxSelector(
    ({ survey }) => survey.surveyQuestion.list
  );

  const mappedQuestions = useMemo(() => {
    return surveyQuestions.map((surveyQuestion) => {
      let answer = selectedSurveyRequest?.answers?.[surveyQuestion._id];

      return { ...surveyQuestion, questionAnswer: answer };
    });
  }, [surveyQuestions, selectedSurveyRequest]);
  return (
    <>
      <tr className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable">
        <td className="arh-border-y-0 arh-border-l-0 arh-border-r arh-border-solid arh-border-borderTable arh-bg-greyColor arh-px-4  arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
          <div
            className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-between arh-py-[0.938rem] "
            onClick={toggleFadeStatus}
          >
            <div className="arh-max-w-parent-table-evaluation arh-flex arh-flex-1 arh-items-center ">
              <div className="arh-mr-[0.625rem] arh-h-[0.438rem] arh-w-[0.438rem] arh-rounded-full"></div>
              <BlackTooltip
                title="Questions"
                placement="top-start"
              >
                <span className="arh-max-w-name-table arh-mt-0.5 arh-line-clamp-2 arh-max-w-fit arh-font-poppins arh-text-xs arh-font-semibold arh-text-black">
                  Questions
                </span>
              </BlackTooltip>
            </div>
            <div
              className={`arh-transition arh-duration-200 ${fadeStatus ? "arh-rotate-180-main -arh-rotate-180 " : "arh-rotate-0"}`}
            >
              {ShapeTable()}
            </div>
          </div>
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
      </tr>

      {fadeStatus &&
        mappedQuestions.map((question) => {
          return (
            <tr
              key={question._id}
              className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable"
            >
              <td className="arh-border-y-0 arh-border-l-0 arh-border-r arh-border-solid arh-border-[#EAECF0] arh-bg-[#FDFDFD] arh-px-12 arh-py-[0.688rem] ">
                <BlackTooltip
                  title={question.question}
                  placement="top-start"
                >
                  <p className="arh-m-0 !arh-ml-[-20px] arh-line-clamp-2 arh-w-full arh-max-w-fit arh-p-0 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                    {question.question}
                  </p>
                </BlackTooltip>
              </td>

              <td className="arh-px-16 arh-py-1">
                <div className="arh-flex arh-w-full arh-items-center arh-justify-center">
                  {question.questionAnswer?.answer ? (
                    <Button
                      variant="green-outlined"
                      onClick={() =>
                        handleShowModalAnswer({
                          question,
                          answer: question.questionAnswer
                        })
                      }
                    >
                      {translator("Voir")}
                    </Button>
                  ) : (
                    <span className="arh-font-medium arh-text-darkGreyColor">
                      -
                    </span>
                  )}
                </div>
              </td>

              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
            </tr>
          );
        })}
    </>
  );
}
